import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2`;
const main = "BytePro";
const sub = "EmbeddedDoc";

class EmbeddedDocService {
  getEmbeddedDocs(fileDataId) {
    return axios
      .get(`${API_URL}/${main}/${sub}/${fileDataId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getEmbeddedDoc(fileDataId, embeddedDocId) {
    return axios
      .get(`${API_URL}/${main}/${sub}/${fileDataId}/${embeddedDocId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new EmbeddedDocService();
